import { AppContext } from 'in-meeting-experience-ui-components/contexts/app/context';
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { callObjectIdSelector } from '../slices/callObject/selectors';
import { meetingIdSelector } from '../slices/google/selectors';
import { fetchRecurringMeetingsList } from '../slices/recurringMeetings/actions';
const useRecurringMeetings = () => {
  const dispatch = useDispatch();
  const meetingID = useSelector(meetingIdSelector);
  const callObjectId = useSelector(callObjectIdSelector);
  const {
    selectors: {
      isInLiveMeeting
    }
  } = useContext(AppContext);
  useEffect(() => {
    if (meetingID && isInLiveMeeting && callObjectId) dispatch(fetchRecurringMeetingsList(meetingID));
  }, [dispatch, meetingID, isInLiveMeeting, callObjectId]);
};
export default useRecurringMeetings;